<template>
  <v-card elevation="10" width="500" class="center-card">
    <h1 class="text-lg-center pa-3">
      <v-layout row align-center>
        <v-flex sm1>
          <v-img :src="require('../assets/images/logo_notext.png')"></v-img>
        </v-flex>
        <v-flex sm11>Summary Tool</v-flex>
      </v-layout>
    </h1>
    <v-divider></v-divider>
    <v-card-text>
      <div v-for="(card, index) in cards" :key="index">
        <div v-show="index === cardIdx">
          <v-layout row wrap align-center>
            <v-flex sm12 md6 class="pa-2">
              <h3 class="text-lg-center">{{ card.title }}</h3>
              <div style="text-align: justify;">
                {{ card.text }}
              </div>
            </v-flex>
            <v-flex sm12 md6>
              <v-img :src="cardImg(index)"></v-img>
            </v-flex>
          </v-layout>
        </div>
      </div>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions class="text-lg-center">
      <div class="action-buttons">
        <v-btn
          flat
          color="primary"
          small
          @click="cardIdx--"
          v-show="cardIdx > 0"
          ><v-icon style="padding-right: 5px;">chevron_left</v-icon>back</v-btn
        >
        <v-btn
          flat
          color="primary"
          small
          v-show="cardIdx < cards.length - 1"
          @click="cardIdx++"
          >next<v-icon style="padding-right: 5px;">chevron_right</v-icon></v-btn
        >
        <v-btn
          flat
          color="success"
          small
          v-show="cardIdx === cards.length - 1"
          @click="skip(true)"
          >done</v-btn
        >
        <v-btn
          flat
          color="warning"
          small
          v-show="cardIdx < cards.length - 1"
          @click="skip()"
          >skip</v-btn
        >
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "SpatialStatsTour",

  data() {
    return {
      cardIdx: 0,
      cards: [
        {
          title: "Description",
          text:
            "The Summary Tool allows you see the distribution of Riparian Intactness in a selected or self-drawn area and generate a report.",
          img: "report_card.png",
        },
        {
          title: "Study Area Mode",
          text:
            "Switch between watershed/waterbody selection and drawing your own area using the button to the right.",
          img: "toggle.png",
        },
        {
          title: "Study Area Selection",
          text:
            "You may select from two levels of watersheds, in addition to nested waterbodies. Use the back button to move back one level.",
          img: "selection.png",
        },
        {
          title: "Draw Mode",
          text:
            "Use the draw buttons on the top right to create or delete plygons. Double-click the mouse to finish and close a polygon, and click on it afterwards to move it. Once you've created a polygon you can name your Study Area.",
          img: "mapdraw.png",
        },
        {
          title: "Create the Summary",
          text:
            "When you've selected a region or drawn/named a Study Area the Create Report button will become available and you can create a report.",
          img: "runbutton.png",
        },
      ],
    };
  },

  methods: {
    skip(success) {
      if (success) {
        this.$swal.fire({
          title: "All Set!",
          icon: "success",
          timer: 900,
          showConfirmButton: false,
        });
      }
      this.$emit("stop-tour");
    },
    cardImg(idx) {
      return require("@/assets/images/" + this.cards[idx].img);
    },
  },
};
</script>

<style scoped>
.center-card {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.action-buttons {
  width: 100%;
  text-align: center;
}
</style>
